/**
 * Partner Dedup & Abandoned Equipment API Client
 * Epic 72: CRM Duplikáció & 60 Napos Gep
 */

import { api } from './client';

// ============================================
// TYPES
// ============================================

export type DuplicateMatchField = 'PHONE' | 'DOCUMENT_NUMBER' | 'EMAIL' | 'NAME' | 'TAX_NUMBER';

export interface DuplicateMatch {
  id: string;
  tenantId: string;
  sourcePartnerId: string;
  matchPartnerId: string;
  matchField: DuplicateMatchField;
  confidence: number;
  resolved: boolean;
  resolvedAction?: 'MERGED' | 'DISMISSED';
  createdAt: string;
  resolvedAt?: string;
}

export interface MergeResult {
  mergeLog: {
    id: string;
    tenantId: string;
    primaryPartnerId: string;
    mergedPartnerId: string;
    rentalsTransferred: number;
    worksheetsTransferred: number;
    invoicesTransferred: number;
    mergedBy: string;
    mergedAt: string;
  };
  primaryPartner: {
    id: string;
    name: string;
    tenantId: string;
  };
  secondaryDeleted: boolean;
}

export interface MergePartnersInput {
  primaryId: string;
  secondaryId: string;
}

export type AbandonedAction = 'DESTROY' | 'SELL' | 'KEEP';

export interface AbandonedEquipmentLog {
  id: string;
  tenantId: string;
  worksheetId: string;
  detectedAt: string;
  action?: AbandonedAction;
  note?: string;
  decidedBy?: string;
  decidedAt?: string;
  createdAt: string;
}

export interface AbandonedProtocolInput {
  action: AbandonedAction;
  note?: string;
}

// ============================================
// API CALLS
// ============================================

export async function listDuplicates() {
  return api.get<{ data: DuplicateMatch[] }>('/partners/duplicates');
}

export async function mergePartners(matchId: string, input: MergePartnersInput) {
  return api.post<{ data: MergeResult }>(`/partners/duplicates/${matchId}/merge`, input);
}

export async function dismissDuplicate(matchId: string) {
  return api.post<{ data: DuplicateMatch }>(`/partners/duplicates/${matchId}/dismiss`, {});
}

export async function listAbandonedEquipment() {
  return api.get<{ data: AbandonedEquipmentLog[] }>('/abandoned-equipment');
}

export async function recordAbandonedProtocol(logId: string, input: AbandonedProtocolInput) {
  return api.post<{ data: AbandonedEquipmentLog }>(`/abandoned-equipment/${logId}/protocol`, input);
}
